webpackJsonp([35783957827783],{

/***/ 37:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(11);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(40);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(39);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  var _props$opacity = props.opacity,
	      opacity = _props$opacity === undefined ? "1" : _props$opacity,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$sizes = props.sizes,
	      sizes = _props$sizes === undefined ? "" : _props$sizes,
	      _props$title = props.title,
	      title = _props$title === undefined ? "" : _props$title,
	      _props$alt = props.alt,
	      alt = _props$alt === undefined ? "" : _props$alt,
	      _props$width = props.width,
	      width = _props$width === undefined ? "" : _props$width,
	      _props$height = props.height,
	      height = _props$height === undefined ? "" : _props$height,
	      _props$transitionDela = props.transitionDelay,
	      transitionDelay = _props$transitionDela === undefined ? "0.5s" : _props$transitionDela;
	
	  return "<img width=\"" + width + "\" height=\"" + height + "\" src=\"" + src + "\" srcset=\"" + srcSet + "\" alt=\"" + alt + "\" title=\"" + title + "\" sizes=\"" + sizes + "\" style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 296:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(37);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	__webpack_require__(296);
	
	var _formSubmissionHandlerEmailList = __webpack_require__(145);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global graphql */
	
	var Home = function (_React$Component) {
	  _inherits(Home, _React$Component);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$Component.call(this));
	  }
	
	  Home.prototype.componentDidMount = function componentDidMount() {
	    (0, _formSubmissionHandlerEmailList.loaded)();
	  };
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      "section",
	      { className: "home page-content", id: "home" },
	      _react2.default.createElement(
	        "div",
	        { className: "container" },
	        _react2.default.createElement(
	          "div",
	          { className: "row" },
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 col-sm-12 side-img" },
	            _react2.default.createElement(
	              "div",
	              { "class": "card" },
	              _react2.default.createElement(_gatsbyImage2.default, {
	                alt: "Card image",
	                className: "card-img",
	                sizes: this.props.images.sizes
	              })
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "col-md-6 col-sm-12" },
	            _react2.default.createElement(
	              "h4",
	              { className: "title" },
	              "A health-minded contemporary dining experience unique to Utah county"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "home-info" },
	              "Contemporarium is a locally owned, locally sourced restaurant."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "home-info" },
	              "Our chefs are specially trained and specialize in meals that are suitable for all diets and health-minded individuals."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "home-info" },
	              "We believe in supporting local suppliers and purchase all of our produce and meats from local farmers."
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "home-info" },
	              "You\u2019ll love our fresh meals for lunch or dinner, bring the whole family to our beautiful locale!"
	            ),
	            _react2.default.createElement("hr", null),
	            _react2.default.createElement(
	              "h4",
	              null,
	              "Sign up for our mailing list and receive special offers!"
	            ),
	            _react2.default.createElement(
	              "div",
	              { className: "custom-card", style: { marginTop: 0 } },
	              _react2.default.createElement(
	                "form",
	                {
	                  id: "gform",
	                  method: "POST",
	                  className: "pure-form pure-form-stacked",
	                  "data-email": "example@email.com",
	                  action: "https://script.google.com/macros/s/AKfycbzRf8a6u5tMJu7MYYQXwqHbT41ZD7WAcmAAz-ByAgkm7_5nGi_p/exec"
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "input-group mb-3" },
	                  _react2.default.createElement("input", {
	                    className: "form-control",
	                    id: "email",
	                    name: "Email",
	                    type: "email",
	                    placeholder: "Email Address",
	                    required: true
	                  }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "input-group-append" },
	                    _react2.default.createElement(
	                      "button",
	                      { className: "btn btn-primary" },
	                      "Subscribe"
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { style: { display: "none" }, id: "thankyou_message" },
	                _react2.default.createElement(
	                  "h4",
	                  null,
	                  "Thanks for subscribing! Pay attention for special offers!"
	                )
	              )
	            ),
	            _react2.default.createElement(
	              "div",
	              {
	                className: "col-12 text-center menu-footer",
	                style: { margin: "20 0" }
	              },
	              "All subscribers are listed in a Google sheet",
	              " ",
	              _react2.default.createElement(
	                "a",
	                {
	                  target: "_blank",
	                  href: "https://docs.google.com/spreadsheets/d/1a3uMDGIvdYdKhFb-sHVevGrHa8KMzkZFpz4-hd3AeBA/edit?usp=sharing"
	                },
	                "here"
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Home;
	}(_react2.default.Component);
	
	exports.default = Home;
	
	// export const pageQuery = graphql`
	//   query homeQueryImage {
	//     imageSharp(id: { regex: "/lemonade/" }) {
	//       sizes(maxWidth: 630) {
	//         ...GatsbyImageSharpSizes
	//       }
	//     }
	//   }
	// `;
	
	module.exports = exports["default"];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _nav = __webpack_require__(29);
	
	var _nav2 = _interopRequireDefault(_nav);
	
	var _breadcrumb = __webpack_require__(15);
	
	var _breadcrumb2 = _interopRequireDefault(_breadcrumb);
	
	var _home = __webpack_require__(136);
	
	var _home2 = _interopRequireDefault(_home);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* global graphql */
	
	var IndexPage = function IndexPage(props) {
	  return _react2.default.createElement(
	    "main",
	    null,
	    _react2.default.createElement(_nav2.default, null),
	    _react2.default.createElement(_breadcrumb2.default, null),
	    _react2.default.createElement(_home2.default, { images: props.data.imageSharp })
	  );
	};
	
	exports.default = IndexPage;
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ }),

/***/ 145:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	function validEmail(email) {
	  // see:
	  var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
	  return re.test(email);
	}
	
	function validateHuman(honeypot) {
	  if (honeypot) {
	    //if hidden form filled up
	    console.log("Robot Detected!");
	    return true;
	  } else {
	    console.log("Welcome Human!");
	  }
	}
	
	// get all data in form and return object
	function getFormData() {
	  var form = document.getElementById("gform");
	  var elements = form.elements; // all form elements
	  var fields = Object.keys(elements).map(function (k) {
	    if (elements[k].name !== undefined) {
	      return elements[k].name;
	      // special case for Edge's html collection
	    } else if (elements[k].length > 0) {
	      return elements[k].item(0).name;
	    }
	  }).filter(function (item, pos, self) {
	    return self.indexOf(item) == pos && item;
	  });
	  var data = {};
	  fields.forEach(function (k) {
	    data[k] = elements[k].value;
	    var str = ""; // declare empty string outside of loop to allow
	    // it to be appended to for each item in the loop
	    if (elements[k].type === "checkbox") {
	      // special case for Edge's html collection
	      str = str + elements[k].checked + ", "; // take the string and append
	      // the current checked value to
	      // the end of it, along with
	      // a comma and a space
	      data[k] = str.slice(0, -2); // remove the last comma and space
	      // from the  string to make the output
	      // prettier in the spreadsheet
	    } else if (elements[k].length) {
	      for (var i = 0; i < elements[k].length; i++) {
	        if (elements[k].item(i).checked) {
	          str = str + elements[k].item(i).value + ", "; // same as above
	          data[k] = str.slice(0, -2);
	        }
	      }
	    }
	  });
	
	  // add form-specific values into the data
	  data.formDataNameOrder = JSON.stringify(fields);
	  data.formGoogleSheetName = form.dataset.sheet || "Email List"; // default sheet name
	  data.formGoogleSendEmail = form.dataset.email || ""; // no email by default
	
	  console.log(data);
	  return data;
	}
	
	function handleFormSubmit(event) {
	  // handles form submit withtout any jquery
	  event.preventDefault(); // we are submitting via xhr below
	  var data = getFormData(); // get the values submitted in the form
	
	  /* OPTION: Remove this comment to enable SPAM prevention, see README.md
	  if (validateHuman(data.honeypot)) {  //if form is filled, form will not be submitted
	    return false;
	  }
	  */
	
	  if (!validEmail(data.Email)) {
	    // if email is not valid show error
	    document.getElementById("email-invalid").style.display = "block";
	    return false;
	  } else {
	    var url = event.target.action; //
	    var xhr = new XMLHttpRequest();
	    xhr.open("POST", url);
	    // xhr.withCredentials = true;
	    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
	    xhr.onreadystatechange = function () {
	      console.log(xhr.status, xhr.statusText);
	      console.log(xhr.responseText);
	      document.getElementById("gform").style.display = "none"; // hide form
	      document.getElementById("thankyou_message").style.display = "block";
	      return;
	    };
	    // url encode form data for sending as post data
	    var encoded = Object.keys(data).map(function (k) {
	      return encodeURIComponent(k) + "=" + encodeURIComponent(data[k]);
	    }).join("&");
	    xhr.send(encoded);
	  }
	}
	// function loaded() {
	//   console.log("contact form submission handler loaded successfully");
	//   // bind to the submit event of our form
	//   var form = document.getElementById("gform");
	//   form.addEventListener("submit", handleFormSubmit, false);
	// }
	
	var loaded = function loaded() {
	  console.log("email list form submission handler loaded successfully");
	  // bind to the submit event of our form
	  var form = document.getElementById("gform");
	  form.addEventListener("submit", handleFormSubmit, false);
	};
	
	exports.loaded = loaded;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-da2698ac25e0242c5c6a.js